const Group = require('./Group')
const GroupMember = require('./GroupMember')
const GroupPost = require('./GroupPost')
const Post = require('./Post')

module.exports = {
    Group: Group,
    GroupMember: GroupMember,
    GroupPost: GroupPost,
    Post: Post
}
